import React, { useState, useEffect } from "react";
import Sidebar from "../../components/Sidebar";
import Content from "../../components/Content";
import OrganisationsNavbar from "../../components/OrganisationsNavbar";
import Organisations from "./Organisations"; //comment
import CustomToaster from "../../components/CustomToaster"; // Import the CustomToaster

const Index = ({ pageID, title }) => {
  const [toggleBtn, setToggleBtn] = useState(false);
  const toggle = () => setToggleBtn((val) => !val);
  const [navTitle, setNavTitle] = useState("Organisations");

  const [openOrganisationAdd, setOpenOrganisationAdd] = useState(false);
  const [filteredOrganisations, setFilteredOrganisations] = useState([]);
  const [toasterVisible, setToasterVisible] = useState(false);
  const [toasterMessage, setToasterMessage] = useState("");
  const [toasterAppearance, setToasterAppearance] = useState("success");
  const [organisationCount, setOrganisationCount] = useState(0);
  const [editMode, setEditMode] = useState(false);
  

  const handleOpenOrganisationAdd = () => {
    setOpenOrganisationAdd(true);
  };

  const handleCloseOrganisationAdd = () => {
    setOpenOrganisationAdd(false);
  };

  const setEditModeOn = () => {
    setEditMode(true);
  };

  const setEditModeOff = () => {
    setEditMode(false);
  };

  const showToaster = (message, appearance) => {
    setToasterMessage(message);
    setToasterAppearance(appearance);
    setToasterVisible(true);

    setTimeout(() => {
      setToasterVisible(false);
    }, 5000); // Hide the toaster after 5 seconds
  };

  const closeToaster = () => {
    setToasterVisible(false);
  };

  useEffect(() => {
    setNavTitle(title);
  }, [title]);

  useEffect(() => {
    let timer;
    if (toasterVisible) {
      timer = setTimeout(() => {
        setToasterVisible(false);
      }, 5000); // Hide the toaster after 5 seconds
    }
    return () => {
      clearTimeout(timer); // Cleanup timeout on unmount or when toasterVisible changes
    };
  }, [toasterVisible]);

  return (
    <div className="top-wrapper data-console-top-wrapper">
      {toasterVisible && (
        <CustomToaster
          message={toasterMessage}
          duration={3000}
          onClose={closeToaster}
          position="right-top"
          appearance={toasterAppearance}
        />
      )}
      <OrganisationsNavbar
        setToggle={toggle}
        navTitle={navTitle}
        type={pageID}
        NavbarCollapse={true}
        handleOpenOrganisationAdd={handleOpenOrganisationAdd}
        setFilteredOrganisations={setFilteredOrganisations} // Pass the setter
        // setEditModeOff={setEditModeOff} // Pass the setEditModeOff function
      />
      <Sidebar toggleBtn={toggleBtn} onCloseButtonClick={() => setToggleBtn(false)} />
      <Content toggleBtn={toggleBtn}>
        <div className="dataconsole-responsvive-body">
          <Organisations
            pageID={pageID}
            title={title}
            openOrganisationAdd={openOrganisationAdd}
            handleCloseOrganisationAdd={handleCloseOrganisationAdd}
            handleOpenOrganisationAdd={handleOpenOrganisationAdd}
            filteredOrganisations={filteredOrganisations} // Pass the filtered organisations
            showToaster={showToaster} // Pass the showToaster function
            setOrganisationCount={setOrganisationCount} // Pass the setOrganisationCount function
            setEditModeOn={setEditModeOn} // Pass the setEditModeOn function
            setEditModeOff={setEditModeOff} // Pass the setEditModeOff function
            editMode={editMode} // Pass the editMode state
          />
        </div>
      </Content>
    </div>
  );
};

export default Index;
